<ng-container *ngIf="busy; else loadingState">
    <ion-skeleton-text [animated]="true" class="m-4 text-xl w-48 rounded"></ion-skeleton-text>
    <ion-skeleton-text [animated]="true" class="m-4 h-20 w-auto rounded"></ion-skeleton-text>
</ng-container>

<ng-template #loadingState>
  <div class="m-4">
    <ion-label class="text-xl" *ngIf="managerInsight">{{ "WALLET.MANAGER_INSIGHT" | transloco }}</ion-label>
    <ion-label class="mt-4 block" *ngIf="managerInsight">{{ managerInsight.description }}</ion-label>
  </div>
</ng-template>